import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "theme"

  connect() {
    super.connect()
    this.sendCurrentTheme()
    this.observeThemeChanges()
  }

  disconnect() {
    super.disconnect()
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  sendCurrentTheme() {
    const theme = document.documentElement.classList.contains("dark") ? "dark" : "light"
    this.send("connect", { theme })
  }

  observeThemeChanges() {
    this.observer = new MutationObserver(() => {
      this.sendCurrentTheme()
    })

    this.observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"]
    })
  }
}
